export default {
	buildMessageError: (errors) => {
		let messages = "";
		if (errors && errors !== null && typeof errors === "object") {
			Object.keys(errors).map(function (key, index) {
				messages += errors[key];
				if (index !== Object.keys(errors).length - 1)
					messages += ", ";
			});
			return messages;
		} return "";
	}
};


// WEBPACK FOOTER //
// ./src/util/message.js